import React, { useState } from 'react';
import './contact.css';
import { profile } from '../data/profileData';

const Contact = () => {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formState;
    const subject = encodeURIComponent(`Portfolio Contact from ${name}`);
    const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`);
    window.location.href = `mailto:${profile.email}?subject=${subject}&body=${body}`;
  };

  const handleChange = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="contact">
      <div className="contact__inner">
        <h2 className="section__title">Get in Touch</h2>
        <p className="contact__subtitle">
          Have a project in mind? Let's work together to create something amazing.
        </p>

        <form className="contact__form" onSubmit={handleSubmit}>
          <div className="form__group">
            <label htmlFor="name" className="form__label">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              className="form__input"
              value={formState.name}
              onChange={handleChange}
              required
              placeholder="Your name"
            />
          </div>

          <div className="form__group">
            <label htmlFor="email" className="form__label">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form__input"
              value={formState.email}
              onChange={handleChange}
              required
              placeholder="your.email@example.com"
            />
          </div>

          <div className="form__group">
            <label htmlFor="message" className="form__label">Message</label>
            <textarea
              id="message"
              name="message"
              className="form__input"
              value={formState.message}
              onChange={handleChange}
              required
              placeholder="Tell me about your project"
              rows="5"
            ></textarea>
          </div>

          <button type="submit" className="btn primary">
            Send Message
          </button>
        </form>

        <div className="contact__social">
          <a href={profile.socials.github} target="_blank" rel="noopener noreferrer" className="social__link">
            GitHub
          </a>
          <a href={profile.socials.linkedin} target="_blank" rel="noopener noreferrer" className="social__link">
            LinkedIn
          </a>
          <a href={profile.socials.instagram} target="_blank" rel="noopener noreferrer" className="social__link">
            Instagram
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;